import types from 'helpers/constants';

const initialState = {
  allergens: [],
  loading: true,
};

// eslint-disable-next-line func-style, default-param-last -- FIXME
function Allergens(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ALLERGENS:
      return {
        ...state,
        allergens: action.payload.allergens,
        loading: false,
      };
    case types.REMOVE_ALLERGEN:
      return {
        ...state,
        allergens: state.allergens.filter(
          allergen => allergen.id !== action.payload.removedItemId
        ),
      };
    case types.LOADING_ALLERGENS:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}

export default Allergens;
